import { useTranslation } from 'react-i18next';
import Modal from '../Modal/Modal';
import './AmazonTokenModal.scss';
import { ReactComponent as AmazonLogo } from '../../icons/amazon.svg';
import { useAppSelector } from '../../hooks';
import { STATE_CONSTANT } from '../../pages/Seller/SellerDashboard';

interface Props {
  isModalOpened: boolean;
  closeModal: () => void;
  sellerId?: string;
}

export default function AmazonTokenModal({
  isModalOpened,
  closeModal,
  sellerId,
}: Props) {
  const user = useAppSelector((s) => s.user.user);
  const activeCompany = useAppSelector((s) => s.user.activeCompany);
  const { t } = useTranslation();

  const button = (
    <a
      data-testid='token-modal-btn'
      className='Text AmazonTokenModal__btn d-flex p-0 align-items-stretch text-decoration-none w-100 overflow-hidden my-4'
      href={`https://sellercentral-europe.amazon.com/apps/authorize/consent?application_id=${process.env.REACT_APP_ID}&state=${user?.Id}.${activeCompany?.company_id}${STATE_CONSTANT}&version=beta`}
    >
      <div className='AmazonTokenModal__icon d-flex align-items-center justify-content-center'>
        <AmazonLogo />
      </div>
      <div
        className='d-flex align-items-center justify-content-center flex-grow-1 px-3'
        id='amazon-connect'
      >
        {t('connect_amazon_btn')}
      </div>
    </a>
  );

  return (
    <Modal
      isOpened={isModalOpened}
      close={closeModal}
      title={
        sellerId ? t('Update merchant token') : t('Connect merchant token')
      }
      name='token-modal'
    >
      <div className='mx-3 pt-3 pb-4 px-3'>
        <div
          style={{
            maxWidth: 504,
          }}
        >
          {sellerId ? (
            <>
              <div className='Title fw-900' data-testid='token-modal-title'>
                {t('Update token')}
              </div>
              <div className='Text' data-testid='token-modal-text'>
                {t(
                  'To Update *seller_id* Merchant token please login to related Amazon Seller Account.'
                ).replace('*seller_id*', sellerId)}
              </div>
            </>
          ) : (
            <>
              <div className='Title fw-900' data-testid='token-modal-title'>
                {t('Connect new token')}
              </div>
              <div className='Text' data-testid='token-modal-text'>
                {t(
                  'To connect token please login to related Amazon Seller Account.'
                )}
              </div>
            </>
          )}
          {button}
        </div>
      </div>
    </Modal>
  );
}
